import TodaysDate from './TodayDate';
import Greeting from './GreetingMessege';
import React, { useEffect,useContext, useState } from 'react';
import TokenService from "../../Services/Token.service";
import { GlobalInfo } from '../../Contexts/GlobalContext';

function DashboardHeader() {
    const { isSidebarVisible } = useContext(GlobalInfo);
    const [userName, setUerName] = useState();
    useEffect(() => {
        const user = TokenService.getUser();
        if (user) {
            setUerName(user.user.first_name);
        }
    }, []);
    return ( 
        <>
            <div  className={`el-topbar el-middle ${!isSidebarVisible ? 'collapsed-body' : ''}`} >
                < Greeting userName = { userName }  /> <TodaysDate/>
            </div> 
        </>
    );
}

export default DashboardHeader;